import RibbonButton from './RibbonButton';
import strings from 'owa-strings/owa-mail-strings';
import { Direction } from 'roosterjs-editor-types';
import { setDirection } from 'roosterjs-editor-api';

const ltr: RibbonButton = {
    key: 'ltr',
    title: () => strings.dirLtr,
    imageSrc: require('../svg/ltr.svg'),
    onExecute: plugin => setDirection(plugin.getEditor(), Direction.LeftToRight),
};

export default ltr;
